import { useQuery } from "@tanstack/react-query";

import type { ProfileItem } from "../../models/ProfileItem";
import { getProfileItems } from "../../repositories/ProfileItemRepository";

export const useProfileItemsQuery = (assetId: number) =>
	useQuery<ProfileItem[], Error>({
		queryKey: ["sectionDimensions", assetId],
		queryFn: ({ signal }) => getProfileItems(assetId, signal),
		enabled: assetId > 0,
		meta: { realtime: ["DIM.GetProfileItems"] },
	});
